export const PRODUCTS_URL = `products`;

export const GET_SHOP_PRODUCTS_MAX_PAGE_SIZE = 2000;
